import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

export const useStyles = createStyles(({ token, css }: any) => ({
  header: css`
    position: sticky;
    top: 0;
    z-index: ${token.zIndexHeader};
    width: 100%;
    padding-inline: 0;
    padding-block: 0;
    height: auto;
  `,
  content: css`
    padding-inline: 0;
    padding-block: 0;
  `,
  footer: css`
    padding-inline: 0;
    padding-block: 0;
  `,
}));

export const useLayoutPageRootStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
